<script>
    import { dbClearAllInvalidItems, clearAllInvalidItems, invalidateItem,user_data, parseCityStateZip } from './stores.js';
    import * as yup from 'yup'; 
    import Cleave from 'cleave.js';    
    import { onMount } from "svelte";
    import Progresscomponent from "./components/progresscomponent.svelte";
    import Chipscompnent from './components/chipscompnent.svelte';
    import Dtemplate from "./components/detailedtemplate.svelte";
    
    let cashout_element;
    let cashout_formatter;
    

    onMount(async() => {
        cashout_formatter = new Cleave(cashout_element, {
            numeral: true,
            prefix: '$',
            noImmediatePrefix: true
        });

    });

    const formSchema = yup.object().shape({
        cashout_element: yup
        .string()
        .required('Expected debt consolidation amount is required to find the best rates.'),
    });
    async function checkNext() {
        clearAllInvalidItems();
        let res = false;
        await formSchema.validate({ 
            cashout_element: cashout_element.value.trim(),
        }).then(function (value) {
            res = true;
        }).catch(function (err) {
                invalidateItem(eval(err.path), err.errors[0]);
            res = false;
        });

    // check loan balance limit
    if (res) {
      if (
        parseInt(cashout_element.value.trim().toString().replace(/[^\d.-]/g, "")) >= 0 &&
        parseInt(cashout_element.value.trim().toString().replace(/[^\d.-]/g, "")) <= 2000000
      ) {
        res = true;
      } else {
        invalidateItem(
            cashout_element,
          "The consolidation amount must be between $50,000 and $2,000,000"
        );
        res = false;
      }
    }


        return res;
    }

    function clearFunction() {
        dbClearAllInvalidItems();
    }

</script>

<Dtemplate
progress_mobile_version={true}
>
    <Progresscomponent 
    pre_next_callback_function={checkNext}
    title="How much debt do you want to consolidate?"
    >
    <div class="formcontainer">
        <input inputmode="numeric" on:keyup={()=>{ clearFunction(); }} bind:this={cashout_element} bind:value={$user_data.debtconsolidationamount} type="text" placeholder="Debt consolidation amount" />
    </div>
    </Progresscomponent>
</Dtemplate>

<style>
.formcontainer {
    margin-top: 40px;
    width: 60%;
    max-width: 350px;
    margin-left: auto;
    margin-right: auto;
}
.formcontainer input {
    width: 100%;
    padding: 10px;
}
@media (max-device-width: 1024px), (max-width: 1023px) {
    .formcontainer {
        width: 100%;
        max-width: 280px;
    }

}

</style>